// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.roles_dashboard__4yfgl {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px 30px 80px 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}

.roles_dashboardContain__gHdlb {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.roles_bodythemedark__\\+pgu- .roles_dashboardContain__gHdlb,
.roles_bodythemedark__\\+pgu- .roles_dashboard__4yfgl,
.roles_bodythemedark__\\+pgu- .roles_cont2__F1WGU {
  background-Color: #0f1824;
}

.roles_top_header__wY04w .roles_top_header_inner__R7\\+11 {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.roles_cont2__F1WGU {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.roles_subLink__MlV\\+B svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.roles_footer__T\\+vWg {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.roles_bodythemelight__sS\\+-A {
  background-color: #fff;
  padding-top: 90px;
}

.roles_bodythemedark__\\+pgu- {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.roles_headerthemelight__hiV4V {
  background-color: #fff;
}

.roles_headerthemedark__Mj8Nq {
  background-color: #132337;
}

.roles_top_header__wY04w {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
}

/* 
LEFT MENU THEME CHANGE
*/
.roles_menuthemelight__zWxpo {
  background-color: #fff;
}

.roles_menuthemedark__\\+RiU\\+ {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.roles_menulinklight__PK4wh span {
  color: #666666 !important;
}

.roles_menulinklight__PK4wh a {
  color: #CBCBCB !important;
}

.roles_menulinklight__PK4wh:hover span, .roles_menulinklight__PK4wh:hover a {
  color: #fff !important;
}

.roles_menulinkdarkSelected__DWw4c {
  background-color: #1c2e45;
  color: #fff;
}

.roles_menuthemelight__zWxpo .roles_menulinklightSelected__0oUik {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #205440;
}

.roles_menulinkdark__UHzLp {
  color: #60677e !important;
}

.roles_menulinklight__PK4wh:hover {
  color: #fff !important;
  background-color: #205440;
}

.roles_menulinkdark__UHzLp:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.roles_headinglight__sFFb2 {
  color: #60677e;
}

.roles_headingdark__HqAwD {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.roles_searchboxlight__ITJcb {
  background-color: #fff;
  border: none;
}

.roles_searchboxdark__FXbvW {
  background-color: #132337;
  color: #fff;
  border: none;
}

.roles_searchboxdark__FXbvW::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.roles_tableheadlight__xTDAq {
  background-color: #205440;
  border-radius: 5px 5px 0px 0px;
}

.roles_tableheadlight__xTDAq th {
  color: #fff;
}

thead .roles_tableheadlight__xTDAq th:first-child,
thead .roles_tableheaddark__J0LSu th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .roles_tableheadlight__xTDAq th:last-child,
thead .roles_tableheaddark__J0LSu th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.roles_table__PWWVQ.roles_table-borderless__MuPJ5 {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.roles_tableheaddark__J0LSu {
  background-color: #1e1e2d;
  color: #fff;
}

.roles_table-borderless__MuPJ5 tr:nth-child(even) {
  background-color: #F9FAFB;
}

.roles_table-borderless__MuPJ5 .roles_left-section__Z0ABk {
  padding-top: 10px;
}

.roles_tablebodylight__0Ou95 td,
.roles_tablebodydark__Ngbad td {
  padding: 1rem 1rem !important;
}

.roles_tablebodylight__0Ou95 {
  background-color: #fff;
}
.roles_tablebodylight__0Ou95:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.roles_tablebodydark__Ngbad {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.roles_tablebodydark__Ngbad:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.roles_paginationlight__yamMe {
  color: #60677e !important;
  font-size: 13px !important;
}

.roles_paginationdark__TjEXJ {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.roles_formthemelight__PmCyW {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.roles_formthemedark__Xh2Nd {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.roles_formthemedark__Xh2Nd ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.roles_viewformlight__IJDiM {
  background-color: #f3f6f9;
}

.roles_permissionboxlight__ftJGG {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.roles_permissionboxdark__DI9iz {
  background-color: #151521;
  border: solid 1px #242434;
}

.roles_errormsgclr__V4ArJ {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.roles_graphclrlight__qRcLf {
  background-color: #fff;
}

.roles_graphclrdark__n\\+HC8 {
  background-color: #1e1e2d;
}

/* 
Counter theme
*/
#roles_card1bglight__y25Vd {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#roles_card1bglight__y25Vd:hover {
  background: #f7fffc;
}

#roles_card1bgdark__AmVLQ {
  background: #392f28;
}

#roles_card1bgdark__AmVLQ:hover {
  background: #f7fffc;
}

#roles_card2bglight__bb8Lp {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#roles_card2bglight__bb8Lp:hover {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #f7fffc;
}

#roles_card2bgdark__R9941 {
  background: #1c3238;
}

#roles_card3bglight__Wiala {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#roles_card3bglight__Wiala:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#roles_card3bgdark__Nisqf {
  background: #3a2434;
}

#roles_card4bglight__IOSx6 {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#roles_card4bglight__IOSx6:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#roles_card4bgdark__HIH4M {
  background: #2f264f;
}

#roles_card1bgdark__AmVLQ a, #roles_card1bgdark__AmVLQ p,
#roles_card2bgdark__R9941 a, #roles_card2bgdark__R9941 p,
#roles_card3bgdark__Nisqf a, #roles_card3bgdark__Nisqf p,
#roles_card4bgdark__HIH4M a, #roles_card4bgdark__HIH4M p {
  color: #fff;
}

/* 
Action button theme
*/
.roles_actionbtnlight__023vz {
  color: rgba(70, 71, 91, 0.8705882353);
}

.roles_actionbtndark__4YaoZ {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.roles_profiledropdownlight__zL-Fd {
  background-color: #fff;
}

.roles_profiledropdowndark__vH2QF {
  background-color: #151521;
}

.roles_settingsection__65PaT #roles_addform__uWqXn.roles_formthemedark__Xh2Nd .roles_savebtn__bECTl {
  background-color: #0a2574;
  color: #fff;
}

#roles_addform__uWqXn.roles_formthemedark__Xh2Nd .roles_savebtn__bECTl {
  background-color: #0a2574;
  color: #fff;
}

.roles_profile_conatiner__Y4Pew {
  border-radius: 5px !important;
}

.roles_bodythemedark__\\+pgu- .roles_ag-theme-alpine__tTn8n .roles_ag-row__2k0hz {
  background: #000 !important;
}

.roles_bodythemedark__\\+pgu- .roles_formbtn__SIUw4 {
  background-color: #0a2574;
}

.roles_bodythemedark__\\+pgu- .roles_resetbtn__nWp-o {
  color: #fff;
  background-color: transparent;
  border: solid 1px #0a2574;
}

.roles_bodythemedark__\\+pgu- .roles_resetbtn__nWp-o:hover {
  background-color: #0a2574;
}

.roles_headingdark__HqAwD span {
  background-color: #132337;
}

.roles_resetbtn__nWp-o {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #205440;
  color: #205440;
  min-width: 113px;
}

.roles_resetbtn__nWp-o:hover,
.roles_resetbtn__nWp-o:active,
.roles_resetbtn__nWp-o:focus {
  background-color: #205440;
  color: #fff;
}

.roles_addBtn__cUza8 {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.roles_addBtn__cUza8 svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.roles_addBtn__cUza8:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.roles_cust_addBtn__RVj47.roles_addBtn__cUza8 svg {
  top: 2px;
}

.roles_deleteBtn__2sSSF {
  min-width: auto;
  padding: 10px 0;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.roles_deleteBtn__2sSSF {
  min-width: auto !important;
  height: 50px !important;
  background-color: #205440 !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  padding: 0.375rem 1rem !important;
}

.roles_deleteBtn__2sSSF:active, .roles_deleteBtn__2sSSF:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.roles_deleteBtn__2sSSF svg {
  position: relative;
  top: -2px;
}

.roles_deleteBtn__2sSSF:hover,
.roles_deleteBtn__2sSSF:active,
.roles_deleteBtn__2sSSF:focus {
  background-color: #205440 !important;
  color: #fff;
  border: none;
}

.roles_confirmBtn__x90jn {
  background-color: #205440;
}

.roles_confirmBtn__x90jn:hover,
.roles_confirmBtn__x90jn:active,
.roles_confirmBtn__x90jn:focus {
  background-color: #205440;
}

.roles_confirmBtn__x90jn svg {
  top: 0;
}

.roles_back_dlt__itEUr {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.roles_delPopContainer__P5QYh .roles_modal-body__ZEecF {
  padding: 25px;
  text-align: center;
}

.roles_delPopContainer__P5QYh .roles_delet_icon__5Qqlk {
  margin-bottom: 11px;
}

.roles_delPopContainer__P5QYh p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.roles_arrowback__avrSX svg {
  fill: #000;
}

.roles_bodythemedark__\\+pgu- .roles_arrowback__avrSX {
  background-color: #0a2574;
  color: #fff;
}

.roles_bodythemedark__\\+pgu- .roles_arrowback__avrSX svg {
  fill: #fff;
}

.roles_bodythemedark__\\+pgu- .roles_drpdwn_btn__JX10t {
  background-color: #132337;
}

.roles_bodythemedark__\\+pgu- .roles_empname__DlgcD {
  color: #60677e !important;
}

.roles_bodythemedark__\\+pgu- .roles_navitemli__0Xjuw a {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

.roles_bodythemedark__\\+pgu- .roles_tabnavli__UamO2 a.roles_settingsgeneral__JWaUi,
.roles_bodythemedark__\\+pgu- .roles_tabnavli__UamO2 a.roles_settingslinks__Nd0Ip:hover {
  background-color: #0a2574;
  color: #fff;
}

.roles_bodythemedark__\\+pgu- .roles_tabnavli__UamO2 a.roles_settingslinks__Nd0Ip {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

@media only screen and (max-width: 1200px) {
  .roles_tableheadlight__xTDAq th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .roles_dashboard__4yfgl {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  #roles_dashboardcont2__pgQDy {
    height: auto !important;
  }
}
@media only screen and (max-width: 767px) {
  .roles_sectionright__Y5Knj {
    float: unset !important;
  }
  .roles_dashboard__4yfgl {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .roles_cont2__F1WGU {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px 10px !important;
  }
  .roles_bodythemelight__sS\\+-A, .roles_bodythemedark__\\+pgu- {
    padding-top: 165px;
  }
}
@media (min-width: 576px) {
  .roles_exer_modal_contain__AF0z0 .roles_modal-dialog__Dhl6V {
    max-width: 1055px;
  }
  .roles_delPopContainer__P5QYh .roles_modal-dialog__Dhl6V {
    max-width: 350px;
  }
}
.roles_indexdiv__U57Ph #roles_addheading__zhrfZ {
  font-size: 18px;
  margin-bottom: 20px;
}
.roles_indexdiv__U57Ph .roles_exportsection__FKCTm {
  float: right;
  width: 100%;
  margin-bottom: 20px;
}

@media only screen and (max-width: 600px) {
  #roles_dashboardcont2__pgQDy {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/roles/index.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAqCA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,yBAlFO;EAmFP,kBAAA;AC1DF;;AD4DA;;;EAGE,yBAjEoB;ACQtB;;AD2DA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACxDF;;AD2DA;;CAAA;AAIA;EACE,wBAtCU;EAuCV,UAtCS;EAuCT,kBAAA;EACA,aA9CiB;EA+CjB,kBAAA;EACA,mBA1GO;EA2GP;;;GAAA;ACtDF;;AD4DA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACzDF;;AD8DA;EACE,YAAA;AC3DF;;AD8DA;EACE,sBA7FY;ACkCd;;AD8DA;;CAAA;AAGA;EACE,sBApGY;EAqGZ,iBAAA;AC3DF;;AD6DA;EACE,yBAnHgB;EAoHhB,iBAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAhHY;ACsDd;;AD6DA;EACE,yBA/HgB;ACqElB;;AD4DA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;ACzDF;;AD4DA;;CAAA;AAGA;EACE,sBAnIY;AC0Ed;;AD2DA;EACE,yBAjJgB;ACyFlB;;AD2DA;;CAAA;AAGA;EACE,yBAAA;ACxDF;;AD2DA;EACE,yBAAA;ACxDF;;AD2DA;EACE,sBAAA;ACxDF;;AD2DA;EACE,yBAlKsB;EAmKtB,WA1JY;ACkGd;;AD0DA;EACE,sCAAA;EACA,sBAAA;EACA,yBA/Lc;ACwIhB;;AD0DA;EACE,yBAAA;ACvDF;;AD0DA;EACE,sBAAA;EACA,yBAxMc;ACiJhB;;AD0DA;EACE,yBArLsB;EAsLtB,WA7KY;ACsHd;;AD0DA;;CAAA;AAGA;EACE,cAjLe;AC0HjB;;AD0DA;EACE,cArLe;AC8HjB;;AD0DA;;CAAA;AAGA;EACE,sBA/LY;EAgMZ,YAAA;ACvDF;;AD0DA;EACE,yBA/MgB;EAgNhB,WArMY;EAsMZ,YAAA;ACvDF;;ADyDA;EACE,cAtMe;ACgJjB;;ADyDA;;CAAA;AAGA;EACE,yBAhPc;EAiPd,8BAAA;ACtDF;;ADwDA;EACE,WApNY;AC+Jd;;ADuDA;;EAEE,0BAAA;ACpDF;;ADsDA;;EAEE,0BAAA;ACnDF;;ADqDA;EACE,kBAAA;AClDF;;ADoDA;EACE,kBAAA;ACjDF;;ADmDA;EACE,oCAAA;EACA,gCAAA;AChDF;;ADmDA;EACE,yBAlOkB;EAmOlB,WA3OY;AC2Ld;;ADkDA;EACE,yBAAA;AC/CF;;ADiDA;EACE,iBAAA;AC9CF;;ADgDA;;EAEE,6BAAA;AC7CF;;AD+CA;EACE,sBAxPY;AC4Md;AD8CE;EACE,yBAAA;EACA,eAAA;AC5CJ;;AD+CA;EACC,0CAAA;EACC,cA9Pe;ACkNjB;AD8CE;EACE,yCAAA;EACA,eAAA;AC5CJ;;ADgDA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,0BAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAzRY;EA0RZ,yBAAA;EACA,qDAAA;AC5CF;;AD8CA;EACE,yBAtRkB;EAuRlB,yBAAA;EACA,eAAA;AC3CF;AD6CE;EACE,cAhSa;ACqPjB;;ADgDA;;CAAA;AAGA;EACE,yBA/SgB;ACkQlB;;ADgDA;EACE,yBAAA;EACA,yBAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,yBAAA;AC5CF;;AD+CA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAlUY;ACsRd;;AD+CA;EACE,yBA9TkB;ACkRpB;;ADgDA;;CAAA;AAGA;EACE,iGAAA;EACA,sBA/UY;ACkSd;;AD+CA;EACE,mBAAA;AC5CF;;AD8CA;EACE,mBAAA;AC3CF;;AD6CA;EACE,mBAAA;AC1CF;;AD4CA;EACE,gGAAA;EACA,sBA5VY;ACmTd;;AD2CA;EACE,gGAAA;EACA,yBAAA;ACxCF;;AD0CA;EACE,mBAAA;ACvCF;;AD0CA;EACE,gGAAA;EACA,sBAxWY;ACiUd;;ADyCA;EACE,gGAAA;EACA,yBAAA;ACtCF;;ADyCA;EACE,mBAAA;ACtCF;;ADyCA;EACE,gGAAA;EACA,sBArXY;AC+Ud;;ADwCA;EACE,gGAAA;EACA,yBAAA;ACrCF;;ADuCA;EACE,mBAAA;ACpCF;;ADuCA;;;;EAIE,WAnYY;AC+Vd;;ADuCA;;CAAA;AAGA;EACE,qCAAA;ACpCF;;ADuCA;EACE,cA3Ye;ACuWjB;;ADwCA;;CAAA;AAGA;EACE,sBAAA;ACrCF;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,yBAtaqB;EAuarB,WA/ZY;AC0Xd;;ADuCA;EACE,yBA1aqB;EA2arB,WAnaY;AC+Xd;;ADuCA;EACE,6BAAA;ACpCF;;ADuCA;EACE,2BAAA;ACpCF;;ADuCA;EACE,yBAvbqB;ACmZvB;;ADuCA;EACE,WAnbY;EAobZ,6BAAA;EACA,yBAAA;ACpCF;;ADuCA;EACE,yBAjcqB;AC6ZvB;;ADwCA;EACE,yBAzcgB;ACoalB;;ADwCA;EACE,eAAA;EACA,gBAzec;EA0ed,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAvec;EAwed,gBAAA;ACrCF;;ADuCA;;;EAGE,yBA7ec;EA8ed,WA9cY;AC0ad;;ADuCA;EACE,gBAAA;EACA,YAAA;EACA,WApdY;EAqdZ,yBA3eY;EA4eZ,YAAA;EACA,eAAA;EACA,gBA9fc;AC0dhB;;ADuCA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpCF;;ADuCA;EACE,WAleY;EAmeZ,yBAzfY;EA0fZ,YAAA;ACpCF;;ADuCA;EACE,QAAA;ACpCF;;ADuCA;EACE,eAAA;EACF,eAAA;EACE,yBA7fW;EA8fX,WA/eY;EAgfZ,eAAA;EACA,gBAvhBc;EAwhBd,YAAA;ACpCF;;ADuCA;EACE,0BAAA;EACA,uBAAA;EACA,oCAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,iCAAA;ACpCF;;ADuCA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpCF;;ADuCA;EACE,kBAAA;EACA,SAAA;ACpCF;;ADuCA;;;EAGE,oCAAA;EACA,WA/gBY;EAghBZ,YAAA;ACpCF;;ADuCA;EACE,yBApjBc;ACghBhB;;ADuCA;;;EAGE,yBA1jBc;ACshBhB;;ADuCA;EACE,MAAA;ACpCF;;ADwCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;ACrCF;;ADwCA;EACE,aAAA;EACA,kBAAA;ACrCF;;ADwCA;EACE,mBAAA;ACrCF;;ADwCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ACrCF;;ADwCA;EACE,UAAA;ACrCF;;ADwCA;EACE,yBApkBqB;EAqkBrB,WA7jBY;ACwhBd;;ADwCA;EACE,UAjkBY;AC4hBd;;ADwCA;EACE,yBAhlBgB;AC2iBlB;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,6BAAA;EACA,yBAAA;EACA,WA/kBY;AC0iBd;;ADwCA;;EAEE,yBA5lBqB;EA6lBrB,WArlBY;ACgjBd;;ADuCA;EACE,6BAAA;EACA,yBAAA;EACA,WA1lBY;ACsjBd;;ADwCA;EACE;IACE,gBAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;EDuCA;IACE,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;ECrCF;EDuCA;IACE,kBAAA;ECrCF;AACF;ADwCA;EACE;IACI,iBAAA;ECtCJ;EDwCA;IACI,gBAAA;ECtCJ;AACF;AAhpBI;EACI,eAAA;EACA,mBAAA;AAkpBR;AAhpBI;EACI,YAAA;EACA,WAAA;EACA,mBAAA;AAkpBR;;AA3oBA;EACI;IACI,wBD2DI;IC1DJ,UD2DG;IC1DH,kBAAA;IACA,aDmDW;EC2lBjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #205440;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #1e1e2d;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #205440;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: calc(100% - 320px);\n  position: relative;\n  left: 290px;\n  padding: 30px 30px 80px 30px;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: #F5F6FA;\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 1rem 1rem !important;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n#card1bglight:hover {\n  background: #f7fffc;\n}\n#card1bgdark {\n  background: #392f28;\n}\n#card1bgdark:hover {\n  background: #f7fffc;\n}\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n#card2bglight:hover {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n#card3bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n#card4bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $darkTheme_updateBtn;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: auto;\npadding: 10px 0;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: auto !important;\n  height: 50px !important;\n  background-color: $primary-color !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  padding: .375rem 1rem !important;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n.back_dlt{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $darkTheme_updateBtn; \n  color: $white-color;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $white-color;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $lightthemetext !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 998px) { \n  #dashboardcont2{\n    height: auto !important;\n  }\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 20px 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 165px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n.indexdiv{\n\n    #addheading{\n        font-size: 18px;\n        margin-bottom: 20px;\n    }\n    .exportsection{\n        float: right;\n        width: 100%;\n        margin-bottom: 20px;\n    }\n}\n\n\n\n\n@media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `roles_dashboard__4yfgl`,
	"dashboardContain": `roles_dashboardContain__gHdlb`,
	"bodythemedark": `roles_bodythemedark__+pgu-`,
	"cont2": `roles_cont2__F1WGU`,
	"top_header": `roles_top_header__wY04w`,
	"top_header_inner": `roles_top_header_inner__R7+11`,
	"subLink": `roles_subLink__MlV+B`,
	"footer": `roles_footer__T+vWg`,
	"bodythemelight": `roles_bodythemelight__sS+-A`,
	"headerthemelight": `roles_headerthemelight__hiV4V`,
	"headerthemedark": `roles_headerthemedark__Mj8Nq`,
	"menuthemelight": `roles_menuthemelight__zWxpo`,
	"menuthemedark": `roles_menuthemedark__+RiU+`,
	"menulinklight": `roles_menulinklight__PK4wh`,
	"menulinkdarkSelected": `roles_menulinkdarkSelected__DWw4c`,
	"menulinklightSelected": `roles_menulinklightSelected__0oUik`,
	"menulinkdark": `roles_menulinkdark__UHzLp`,
	"headinglight": `roles_headinglight__sFFb2`,
	"headingdark": `roles_headingdark__HqAwD`,
	"searchboxlight": `roles_searchboxlight__ITJcb`,
	"searchboxdark": `roles_searchboxdark__FXbvW`,
	"tableheadlight": `roles_tableheadlight__xTDAq`,
	"tableheaddark": `roles_tableheaddark__J0LSu`,
	"table": `roles_table__PWWVQ`,
	"table-borderless": `roles_table-borderless__MuPJ5`,
	"left-section": `roles_left-section__Z0ABk`,
	"tablebodylight": `roles_tablebodylight__0Ou95`,
	"tablebodydark": `roles_tablebodydark__Ngbad`,
	"paginationlight": `roles_paginationlight__yamMe`,
	"paginationdark": `roles_paginationdark__TjEXJ`,
	"formthemelight": `roles_formthemelight__PmCyW`,
	"formthemedark": `roles_formthemedark__Xh2Nd`,
	"viewformlight": `roles_viewformlight__IJDiM`,
	"permissionboxlight": `roles_permissionboxlight__ftJGG`,
	"permissionboxdark": `roles_permissionboxdark__DI9iz`,
	"errormsgclr": `roles_errormsgclr__V4ArJ`,
	"graphclrlight": `roles_graphclrlight__qRcLf`,
	"graphclrdark": `roles_graphclrdark__n+HC8`,
	"card1bglight": `roles_card1bglight__y25Vd`,
	"card1bgdark": `roles_card1bgdark__AmVLQ`,
	"card2bglight": `roles_card2bglight__bb8Lp`,
	"card2bgdark": `roles_card2bgdark__R9941`,
	"card3bglight": `roles_card3bglight__Wiala`,
	"card3bgdark": `roles_card3bgdark__Nisqf`,
	"card4bglight": `roles_card4bglight__IOSx6`,
	"card4bgdark": `roles_card4bgdark__HIH4M`,
	"actionbtnlight": `roles_actionbtnlight__023vz`,
	"actionbtndark": `roles_actionbtndark__4YaoZ`,
	"profiledropdownlight": `roles_profiledropdownlight__zL-Fd`,
	"profiledropdowndark": `roles_profiledropdowndark__vH2QF`,
	"settingsection": `roles_settingsection__65PaT`,
	"addform": `roles_addform__uWqXn`,
	"savebtn": `roles_savebtn__bECTl`,
	"profile_conatiner": `roles_profile_conatiner__Y4Pew`,
	"ag-theme-alpine": `roles_ag-theme-alpine__tTn8n`,
	"ag-row": `roles_ag-row__2k0hz`,
	"formbtn": `roles_formbtn__SIUw4`,
	"resetbtn": `roles_resetbtn__nWp-o`,
	"addBtn": `roles_addBtn__cUza8`,
	"cust_addBtn": `roles_cust_addBtn__RVj47`,
	"deleteBtn": `roles_deleteBtn__2sSSF`,
	"confirmBtn": `roles_confirmBtn__x90jn`,
	"back_dlt": `roles_back_dlt__itEUr`,
	"delPopContainer": `roles_delPopContainer__P5QYh`,
	"modal-body": `roles_modal-body__ZEecF`,
	"delet_icon": `roles_delet_icon__5Qqlk`,
	"arrowback": `roles_arrowback__avrSX`,
	"drpdwn_btn": `roles_drpdwn_btn__JX10t`,
	"empname": `roles_empname__DlgcD`,
	"navitemli": `roles_navitemli__0Xjuw`,
	"tabnavli": `roles_tabnavli__UamO2`,
	"settingsgeneral": `roles_settingsgeneral__JWaUi`,
	"settingslinks": `roles_settingslinks__Nd0Ip`,
	"dashboardcont2": `roles_dashboardcont2__pgQDy`,
	"sectionright": `roles_sectionright__Y5Knj`,
	"exer_modal_contain": `roles_exer_modal_contain__AF0z0`,
	"modal-dialog": `roles_modal-dialog__Dhl6V`,
	"indexdiv": `roles_indexdiv__U57Ph`,
	"addheading": `roles_addheading__zhrfZ`,
	"exportsection": `roles_exportsection__FKCTm`
};
export default ___CSS_LOADER_EXPORT___;
